import React, { useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import api from '../../../services/API';
import RemoteTable from '../RemoteTable';

export default function TokensIntegracao() {
  const [nome, setNome] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tableKey, setTableKey] = useState(0);

  const fecharModal = () => {
    setNome('');
    setShowModal(false);
  };

  const atualizarTabela = () => {
    setTableKey(prev => prev + 1);
  };

  const alterarStatus = async (token) => {
    try {
      await api.put(`/api/tokens-integracao/${token.id}`, {
        ativo: !token.ativo,
      });
      atualizarTabela();
    } catch (error) {
      toast.error('Erro ao atualizar token', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  const columns = [
    {
      dataField: 'nome',
      text: 'Nome',
      sort: true,
    },
    {
      dataField: 'ativo',
      text: 'Status',
      sort: true,
      formatter: (cell, row) => (
        <button
          className="bg-transparent border-0"
          type="button"
          onClick={() => alterarStatus(row)}
        >
          <label className="switch">
            {row.ativo ? (
              <input type="checkbox" checked disabled />
            ) : (
              <input type="checkbox" disabled />
            )}
            <span className="slider round"></span>
          </label>
        </button>
      ),
    },
    {
      dataField: 'token',
      text: 'Token',
      sort: true,
      formatter: cell => (
        <span style={{ wordBreak: 'break-all' }}>
          {cell}
        </span>
      ),
    },
  ];

  const criarToken = async (event) => {
    event.preventDefault();

    if (!nome.trim()) {
      toast.error('Informe o nome', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    setEnviando(true);
    try {
      await api.post('/api/tokens-integracao', { nome });
      fecharModal();
      atualizarTabela();
      toast.success('Token criado com sucesso', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } catch (error) {
      toast.error(error.response?.data?.erro || 'Erro ao criar token', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
        <h4 className="f-black mb-0">Tokens de Integração</h4>
        <button className="btn-primario-slim" onClick={() => setShowModal(true)}>
          <i className="fa fa-plus mr-2"></i>
          Novo token
        </button>
      </div>
      <hr className="hr-loja mt-0 mb-4" />

      <RemoteTable
        key={tableKey}
        dataId="id"
        url="/api/tokens-integracao"
        colunas={columns}
        ordenacaoInicial={{ campo: 'id', direcao: 'desc' }}
      />

      <Modal
        show={showModal}
        onHide={fecharModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Novo token</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form" onSubmit={criarToken}>
            <label htmlFor="nome">Nome</label>
            <input
              id="nome"
              name="nome"
              type="text"
              placeholder="Nome"
              onChange={(event) => setNome(event.target.value)}
              value={nome}
              autoFocus
            />
            <div className="d-flex justify-content-between mt-4">
              <button
                type="button"
                className="btn-secundario px-2"
                onClick={fecharModal}
                disabled={enviando}
              >
                CANCELAR
              </button>
              {enviando ? (
                <button disabled className="btn-primario" type="submit">
                  SALVANDO...
                </button>
              ) : (
                <button className="btn-primario" type="submit">
                  SALVAR
                </button>
              )}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
